import React from 'react';

import { Team } from '../../../../../../types/entity.types';

import Button from '../../../../../common/button/Button';
import Modal from '../../../../../common/modal/Modal';

import '../team-modals.scss';

type Props = {
  show: boolean;
  close: () => void;
  team?: Team;
  onDeleteClick: () => void;
};

const DeleteTeamConfirmationModal = ({ show, close, team, onDeleteClick }: Props) => (
  <Modal show={show}>
    <section className="team-modals">
      <h1 className="team-modals__header">Delete Team: {team?.teamName}</h1>
      <p className="team-modals__message">
        Deleting the team will remove all members from this team and all team points will be lost!
      </p>
      <div className="team-modals__button-container">
        <Button text="Cancel" onClick={close} />
        <Button text="Delete Team" onClick={onDeleteClick} />
      </div>
    </section>
  </Modal>
);

export default DeleteTeamConfirmationModal;
